import { graphql } from 'gatsby';

import { styled } from '@mui/material';

import { ImageWithTextOverlay } from '@mewa/ui';

import { imagePopulate } from '../../../../libs/strapi-populates';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiResponsiveImageData } from './image';

export const ImageWithTextOverlayFragment = graphql`
  fragment ImageWithTextOverlayFragment on STRAPI__COMPONENT_SHARED_IMAGE_WITH_TEXT_OVERLAY {
    text
    image {
      ...StrapiImageFragment
    }
    strapi_component
  }
`;

export const componentName = 'shared.image-with-text-overlay';

export type ImageWithTextOverlayData = {
  text: string;
  image: StrapiResponsiveImageData;
  strapi_component: typeof componentName;
};

export type ImageWithTextOverlayPreview = ImageWithTextOverlayData;

export const isImageWithTextOverlay = (
  component: PossibleContentSections,
): component is ImageWithTextOverlayData => {
  return component.strapi_component === componentName;
};

export const StrapiImageWithTextOverlay = ({
  text,
  image,
}: ComponentProps<ImageWithTextOverlayData>) => {
  return (
    <Wrapper>
      <ImageWithTextOverlay
        text={text}
        image={<StrapiImage responsiveImage={image} />}
      />
    </Wrapper>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  marginBottom: '45px',
  marginTop: '50px',

  [theme.breakpoints.up('sm')]: {
    marginBottom: '80px',
  },

  [theme.breakpoints.up('md')]: {
    marginBottom: '150px',
  },

  [theme.breakpoints.up('md')]: {
    marginTop: '100px',
  },
}));

export const config = {
  isComponent: isImageWithTextOverlay,
  Component: StrapiImageWithTextOverlay,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  populationParams: { image: imagePopulate },
  componentName,
  mapProperties: (imageWithTextOverlay): ImageWithTextOverlayData | null =>
    imageWithTextOverlay.strapi_component === componentName
      ? imageWithTextOverlay
      : null,
};
